import Drawer from '@mui/material/Drawer'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'

import StyledTable from '@components/StyledTable'
import { formatDateTime } from '@util/date-util'

import type { HistorySelection } from '../types/HistorySelection'
import type { HoofdnetOpdrachtStatus } from '../types/HoofdnetOpdrachtStatus'
import type { LeveringStatus } from '../types/LeveringStatus'

interface Props {
  history: Array<HoofdnetOpdrachtStatus | LeveringStatus>
  selection: HistorySelection
  onClose: () => void
}

const headerCells = [
  { id: 'status', numeric: false, label: 'Status' },
  { id: 'changed', numeric: false, label: 'Gewijzigd' },
]

const changedField2statusText = {
  opdracht: 'statusText',
  planning: 'planStatusText',
  levering: 'leveringStatusText',
}

const defaultSort = (x, y) =>
  Number(new Date(y.changed)) - Number(new Date(x.changed))

export const History = ({ history, selection, onClose }: Props) => {
  const logToRender = history.filter((item) => {
    if (selection.leveringId) {
      return (item as LeveringStatus).leveringId === selection.leveringId
    }
    return item.changedFields.includes(selection.changedField)
  })

  return (
    <Drawer
      data-testid="opdrachthoofdnet-historie"
      anchor="right"
      open={true}
      onClose={onClose}
    >
      <Typography
        variant="h5"
        sx={{
          color: '#1a4d99',
          fontFamily: 'Aller',
          fontSize: '24px',
          fontWeight: 200,
          margin: 2,
          padding: '24px',
          width: '100%',
        }}
      >
        Historie
      </Typography>
      <StyledTable headerCells={headerCells} {...({} as any)}>
        {[...logToRender].sort(defaultSort).map((item) => {
          const { opdrachtId, changed } = item

          return (
            <TableRow key={`${opdrachtId}-${changed}`}>
              <TableCell>
                {item[changedField2statusText[selection.changedField]]}
              </TableCell>
              <TableCell>{formatDateTime(changed)}</TableCell>
            </TableRow>
          )
        })}
      </StyledTable>
    </Drawer>
  )
}
